import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Grid } from '@ui-propulsion/react-components';
import styles from './prosAndCons.module.scss';

export default function ProsAndCons({
  headline = '',
  prosTitle = '',
  consTitle = '',
  pros = [],
  cons = [],
}) {
  return (
    <div className={styles.prosCons}>
      <div className={styles.header}>
        <h2>{headline}</h2>
      </div>
      <Grid container className={styles.prosConsContainer}>
        <Grid item xs={12} sm={6} className={styles.pros}>
          <div className={styles.comparisonTitle}>
            <h3>{prosTitle}</h3>
          </div>
          <div>
            <ol className={styles.comparisonList}>
              {pros?.map((item, index) => {
                const key = `pros + ${index}`;
                return (
                  <li key={key} className={styles.pros} data-testid={item}>
                    {parse(item)}
                  </li>
                );
              })}
            </ol>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} className={styles.cons}>
          <div className={styles.comparisonTitle}>
            <h3>{consTitle}</h3>
          </div>
          <div>
            <ol className={styles.comparisonList}>
              {cons?.map((item, index) => {
                const key = `cons + ${index}`;
                return (
                  <li key={key} className={styles.cons} data-testid={item}>
                    {parse(item)}
                  </li>
                );
              })}
            </ol>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

ProsAndCons.propTypes = {
  headline: PropTypes.string,
  prosTitle: PropTypes.string,
  consTitle: PropTypes.string,
  pros: PropTypes.array,
  cons: PropTypes.array,
};
